
import StatusBar from '../components/StatusBar.vue';
import PopupPickerSelector from '../components/PopupPickerSelector.vue'; 
import XInput from 'vux/src/components/x-input/index.vue';
import XAddress from 'vux/src/components/x-address/index.vue';
import CONSTANTS from '../constants/index';
import PopupPicker from 'vux/src/components/popup-picker/index.vue';
import XDialog from 'vux/src/components/x-dialog/index.vue';
import {TransferDomDirective as TransferDom} from 'vux/src/directives/transfer-dom/index.js';
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import utils from '../utils/index';
import InlineCheckBox from '../components/InlineCheckBox.vue';

export default {
name: 'SubmitOrder',
data(){
return {
wunian: '0',
aaa: [],
bbb: '',

isRead: false,
isShowChild: false,
showContactDialog: false,
address: [],
policyAndInvtype: null,
tjNewVhlTax: null,
submitRes: {},

uploadToken: '',

uploaderInstance: {},
PICKER_OPTIONS: {

/* POLICY_STYLES:[
Object.keys(CONSTANTS.BASE_BEAN.POLICY_STYLES).map(key => {
return {
name: CONSTANTS.BASE_BEAN.POLICY_STYLES[key],
value: `${key}`,
};
}),
], */

INVTYPE:[
Object.keys(CONSTANTS.BASE_BEAN.INVTYPE).map(key => {
return {
name: CONSTANTS.BASE_BEAN.INVTYPE[key],
value: `${key}`,
};
}),
],

TAX_RELIF: [
Object.keys(CONSTANTS.BASE_BEAN.TAX_RELIF).map(key => {
return {
name: CONSTANTS.BASE_BEAN.TAX_RELIF[key],
value: `${key}`,
};
}),
],

TAX_COMPANY: [
Object.keys(CONSTANTS.BASE_BEAN.TAX_COMPANY).map(key => {
return {
name: CONSTANTS.BASE_BEAN.TAX_COMPANY[key],
value: `${key}`,
};
}),
],

SETTLE_Add: [
Object.keys(CONSTANTS.BASE_BEAN.SETTLE_Add).map(key => {
return {
name: CONSTANTS.BASE_BEAN.SETTLE_Add[key],
value: `${key}`,
};
}),
],
},
}
},
components: {
StatusBar, PopupPickerSelector, XAddress, PopupPicker, XDialog, InlineCheckBox, XInput,
},
directives: {
TransferDom,
},
computed: {
...mapState({
flowId: 'flowId',
cityList: 'cityList' ,
cityGroup: 'cityGroup',
riskFlag: state => state.quote.riskFlag ,
calPremiumResult: state => state.quote.calPremiumResult ,
quoteInfo: state => state.quote.quoteInfo ,
hasReadAgreement: state => state.quote.hasReadAgreement,
policyStyles: state => state.quote.policyStyles,
deptCode: state => state.deptCode,
insuredTips: (state) => state.insuredTips,
applicantTips: (state) => state.applicantTips
}),
...mapGetters({
getNewEnergyFlag: 'quote/getNewEnergyFlag',
getSyRisk: 'quote/getSyRisk',
getJqRisk: 'quote/getJqRisk',
getClauseList: 'quote/getClauseList',
getSwitchList:'quote/getSwitchList',
getIsDigital:'quote/getIsDigital'
}),
POLICY_STYLES(){
return CONSTANTS.BASE_BEAN.POLICY_STYLES;
},
isTjNew(){
let vm = this;
let nowTime = new Date();
let nowTimeStr =`${nowTime.getFullYear()}-${nowTime.getMonth()+1}-${nowTime.getDate()}`;
let tempTime = utils.translateTimeDate((vm.quoteInfo.vehicle.singeinDate));
let diff = utils.daysBetween(nowTimeStr, tempTime);
let licenseNo = vm.quoteInfo.vehicle.licenseNo;
if(vm.cityGroup.indexOf('120000') !=-1 && (diff<270 || licenseNo == '*-*')){ // 天津新车
return true;
}else{
return false;
}
},
},
vuerify: {











































"tjNewVhlTax.vhlTax.taxCompancyCode": [// 特殊处理
{
test(value){
if(!this.isTjNew || !this.riskFlag.jqFlag){// 非天津新车 or 没购买交强险
return true;
}else{
return value != '';
}
},
message: '请输入税务机构',
},
],
"tjNewVhlTax.vhlTax.paidFreeCertificate": [// 特殊处理
{
test(value){
if(!this.isTjNew || !this.riskFlag.jqFlag || (this.vhlTax.taxRelifFlag != '03' && this.vhlTax.taxRelifFlag != '04'&& this.vhlTax.taxRelifFlag != '05')){

return true;
}else{
return value != '';
}
},
message: '请输入减免税凭证号',
},
],
"tjNewVhlTax.settleAddressCode": [// 特殊处理
{
test(value){
if(!this.isTjNew || !this.riskFlag.jqFlag){// 非天津新车 or 没购买交强险
return true;
}else{
return value != '';
}
},
message: '请选择车辆落户地址',
},
]
},
methods:{
...mapMutations({
setPolicyAndInvtype: 'quote/setPolicyAndInvtype',
setPolicyAdress: 'quote/setPolicyAdress',
setTjNewVhlTax: 'quote/setTjNewVhlTax',
setQuoteInfo: 'quote/setQuoteInfo',
}),
...mapActions({
officialApply: 'quote/officialApply',
payment: 'quote/payment',
supplement: 'quote/supplement',
getVehicleInspectionRecord: 'quote/getVehicleInspectionRecord',
getVehicleInspectionGetShortLinks: 'quote/getVehicleInspectionGetShortLinks',
}),
modifyOrder(){

this.showContactDialog = false;
this.$vux.loading.show();
const quoteInfoClone = utils.deepClone(this.quoteInfo);
quoteInfoClone.riskList.forEach(item => {
delete item['quotationNo'];
});

this.setQuoteInfo(quoteInfoClone);

this.officialApply()
.then(res=>{
this.$vux.loading.hide();

if (this.getNewEnergyFlag) {
this.$router.push({name: 'AdujustInsuranceEnergy'});
} else {
this.$router.push({name: 'AdujustInsurance'});
}
})
.catch(err=>{
this.$vux.loading.hide();
Toast(err);
});
},
unread(){
this.isRead = false;
},
gotoUsercenter(){

this.showContactDialog = false;
let phone = this.quoteInfo.owner.mobilePhone;
const proposalNo = this.submitRes && this.submitRes.underwriteResultList && this.submitRes.underwriteResultList[0].proposalNo || ''
utils.stopVideo(this.flowId, proposalNo);
setTimeout(() => {
window.location.href = `/eb-web/vue/member/`;
}, 1000);

},

initPolicyAndInvtype(){
let vm = this;
if(vm.getSwitchList.disablePaperInvoiceSwitch==='1'){ // 条件
CONSTANTS.BASE_BEAN.INVTYPE = {
2: "电子发票"
}
var invtypeList = Object.keys(CONSTANTS.BASE_BEAN.INVTYPE).map(key => {
return {
name: CONSTANTS.BASE_BEAN.INVTYPE[key],
value: `${key}`,
}
})
this.PICKER_OPTIONS.INVTYPE = [invtypeList]
vm.quoteInfo.applicant.invtype = '2';
}

if (vm.getIsDigital === 1) {
CONSTANTS.BASE_BEAN.INVTYPE = {
4: "数电普票"
}
var invtypeList = Object.keys(CONSTANTS.BASE_BEAN.INVTYPE).map(key => {
return {
name: CONSTANTS.BASE_BEAN.INVTYPE[key],
value: `${key}`,
}
})
this.PICKER_OPTIONS.INVTYPE = [invtypeList]
vm.quoteInfo.applicant.invtype = '4';
} else if (vm.getIsDigital === 0) {
this.PICKER_OPTIONS.INVTYPE = []
vm.quoteInfo.applicant.invtype = '';
} else if (vm.getIsDigital === 2 && vm.quoteInfo.applicant.invtype === '4') {
vm.quoteInfo.applicant.invtype = '2';
}
vm.policyAndInvtype = {
deliveryInfo: {
name: vm.quoteInfo.applicant.name || '',//收件人
mobilePhone: vm.quoteInfo.applicant.phone || '',//手机号码
address: vm.quoteInfo.applicant.address ||vm.quoteInfo.insured.address || '', // 地址
},
invtype: vm.quoteInfo.applicant.invtype || '0',//发票类型
/* policyStyles: (vm.quoteInfo.base.busiAttrConfig && vm.quoteInfo.base.busiAttrConfig.policyStyles) || '0',// 保单样式 */
email: vm.quoteInfo.applicant.email || '', // 邮箱
};
vm.tjNewVhlTax = {
vhlTax: {
taxRelifFlag : (vm.getJqRisk && vm.getJqRisk.vhlTax.taxRelifFlag) || '02',
taxCompancyCode: (vm.getJqRisk && vm.getJqRisk.vhlTax.taxCompancyCode) || '',
taxCompancyName: (vm.getJqRisk && vm.getJqRisk.vhlTax.taxCompancyName) || '',
paidFreeCertificate: '', // 完税凭证号
},
settleAddressCode: vm.quoteInfo.vehicle.settleAddressCode || '',
};
},
setAdress(){
let vm = this;

vm.setPolicyAdress(vm.policyAndInvtype);
},

validate(){
let check = {
msg: '',
valid: true,
};
if (this.$vuerify.check()) {
check.msg = '';
check.valid = true;

} else {
let err = this.$vuerify.$errors;
check.msg = err[Object.keys(err)[0]][0];
check.valid = false;
}
return check;
},

goCheckCar() {
let vm = this;
vm.$vux.loading.show();

vm.getVehicleInspectionRecord();
if (vm.submit('goCheckCar')) {

vm.officialApply().then(() => {

vm.getVehicleInspectionGetShortLinks().then(res => {
vm.$vux.loading.hide();
if (res && res.longUrl) {
vm.$router.push({name: 'check_car', query: {longUrl: res.longUrl}})
} else {
Toast('获取验车失败');
}
}).catch(err=>{
vm.$vux.loading.hide();
Toast(err);
})
}).catch(err=>{
vm.$vux.loading.hide();
Toast(err);
})
}
},

saveFlowBeforeSubmit(){

return this.officialApply()
.then(()=>{
return this.supplement()
});

},

checkOrder(){
let vm = this;
return $http.submitOrder({
query: {flowId: this.flowId},
data: {}
})
.then(response=>{
this.submitRes = response && response.result;

const proposalNo = response && response.result && response.result.underwriteResultList && response.result.underwriteResultList[0].proposalNo
utils.stopVideo(this.flowId, proposalNo).then(()=>{
utils.startVideo()
})
if (response.resultCode === '0') {

return response.result;
} else if (response.resultCode === 'E12003') {

vm.showContactDialog = true;
return Promise.reject();
} else if (response.resultCode === 'E12002') {

vm.showContactDialog = true;
return Promise.reject();
} else if (response.resultCode === '99') {
if(response.errorMsg.indexOf('Exception')!==-1 || response.errorMsg.indexOf('exception')!==-1 ){
return Promise.reject('系统繁忙，请稍后再试：核心报错');
}else if (response.errorMsg.indexOf('已生成投保单号') >= 0) {
return Promise.reject(response.errorMsg);
} else {
return Promise.reject(response.errorMsg);
}
} else if (response.resultCode == 'E12017') {

vm.showContactDialog = true;
return Promise.reject();
} else if (response.resultCode == 'E22001') {
if(response.errorMsg && response.errorMsg.indexOf('特约中存在需编辑内容，请核实')>=0) {

return Promise.reject('系统繁忙，请稍后重新提交订单');
}

if(response.errorMsg.indexOf('Exception')!==-1 || response.errorMsg.indexOf('exception')!==-1 ){
return Promise.reject('系统繁忙，请稍后再试：核心报错');
}else {
return Promise.reject(response.errorMsg);
}
} else if(response.resultCode == '3'){
this.$router.push({
path: '/holder_msg',
name: 'HolderMsg',
params: {
type: response.errorMsg
}
})
switch(response.errorMsg){
case '1':return Promise.reject('投保人实名失败，请确认录入是否有误');break;
case '2':return Promise.reject('被保人实名失败，请确认录入是否有误');break;
case '4':return Promise.reject('投保人、被保人实名失败，请确认录入是否有误');break;
}
}  else if (response.resultCode === 'E12004') {
return Promise.reject(response.errorMsg);
}else {
let err = response.errorMsg || "系统繁忙，请稍后重新提交订单";
return Promise.reject(err);
}
})
},

getPayment(orderNo) {
let vm = this;
return vm.payment({
flowId: vm.flowId,
payMethod: '07', // 在线支付
orderNo,
})
.then(res=>{
if(res.resultCode == '0'){
return res.result;
}else{
return Promise.reject(err.errorMsg);
}
})
},

goWxPay(applyNo) {
const proposalNo = this.submitRes && this.submitRes.underwriteResultList && this.submitRes.underwriteResultList[0].proposalNo  || '';
utils.stopVideo(this.flowId, proposalNo);
setTimeout(() => {
window.location = `${
process.env.VUE_APP_PAYLOCATION
}&applyNo=${applyNo}&PayChannel=06`;
}, 1000);

},

getElecSignConfig() {
return $get.queryElecSignConfig({
query: {
deptCode: this.deptCode,
mediaSource: "wsc",
origSys: "wsc",
},
})
.then(res=>{
const obj = {
enableSigned: '0'
}
if(res.resultCode == '0'){
Object.assign(obj, res.result)
}
return Promise.resolve(obj);
})
},

goElecPage(queryObj){
this.$router.push({
name: 'ElecPage',
query: queryObj
});
},

goPayOrder(res){
const proposalNo = res && res.underwriteResultList && res.underwriteResultList[0].proposalNo
this.$router.push({
name: 'PayOrder',
query: {
orderNo: res.orderNo,
proposalNo: proposalNo
}
});
},

submit(setUpFlag){
let validate = this.validate();
if(!validate.valid){
Toast(validate.msg);
return
}

let vm = this;












vm.setPolicyAndInvtype(vm.policyAndInvtype);

if(vm.isTjNew){
setTjNewVhlTax(vm.tjNewVhlTax);
}
if (setUpFlag === 'goCheckCar') return true;

vm.saveFlowBeforeSubmit()
.then(res=>{
return vm.checkOrder();
})
.then(res=>{


let underwriteResultListStatus = false;
if (res && res.underwriteResultList) {
underwriteResultListStatus = res.underwriteResultList.every(item => {

return item.underWriteState == '3';
})
}
if (underwriteResultListStatus &&  vm.quoteInfo.applicant.identifyType == '01') {
vm.getElecSignConfig().then(result => {
if (result.enableSigned == "1") {
let queryObj = {};
if (res && res.underwriteResultList[0]) {
queryObj.proposalNo = res.underwriteResultList[0].proposalNo;
}
if (res && res.underwriteResultList[1]) {
queryObj.relProposalNo = res.underwriteResultList[1].proposalNo;
}
vm.goElecPage(queryObj)
} else {
vm.goPayOrder(res)
}
})
} else {
vm.goPayOrder(res)
}
})
.then(applyNo=>{

})
.catch(err=>{
if(err){
Toast(err);
}

const proposalNo = this.submitRes && this.submitRes.underwriteResultList && this.submitRes.underwriteResultList[0].proposalNo
utils.stopVideo(this.flowId, proposalNo).then(()=>{
utils.startVideo()
})
})
},
},
watch: {
hasReadAgreement(val){
this.isRead = this.hasReadAgreement;
}
},
created(){
this.initPolicyAndInvtype();
},
mounted(){


utils.stopVideo(this.flowId).then(()=>{
utils.startVideo('','',() => {
utils.createOperationVideo("LOAD_PAGE",'确认订单');
})
})
},
beforeDestroy(){
const proposalNo = this.submitRes && this.submitRes.underwriteResultList && this.submitRes.underwriteResultList[0].proposalNo
utils.stopVideo(this.flowId, proposalNo).then(()=>{
utils.startVideo()
})
}
}
